/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from 'react';
import { numberWithCommas } from "utilities/helper";
import http from 'utilities/http';
import {IMG_URL} from "utilities/constants";
import { formatSku } from 'utilities/helper';

export default function SlideImage({ location, sku, mainSku, fakePositionClass }) {
    if (location.top == null) {
        return <></>;
    }
    const [imgUrl, setimgUrl] = useState(sku ? '/images/Bookmark.svg' : '/images/Bookmark-white.svg');
    const [showMode, setShowMode] = useState(null);
    const [info, setInfo] = useState(null);

    const fetchData = async () => {
        const product = await http(`/rest/V1/vne/products/${`${formatSku(sku)}`}`, {}, { token: 'default' });
        const imageAttribute = product.custom_attributes?.find(f => f.attribute_code == 'image');
        product.imgUrl = imageAttribute ? IMG_URL + imageAttribute.value : '/images/img-rectangle.png';
        const urlKey = product.custom_attributes.find(f => f.attribute_code == 'url_key')?.value;
        product.urlKey = urlKey;

        const vendor = await http(`/rest/V1/products/vendor/${product.id}`, {}, { token: 'default' });
        product.vendor = vendor.company || vendor.shop_name || vendor.name || vendor.vendor_id ;
        product.vendorLogo = vendor.logo || "/images/icon-app.svg";

        setInfo(product);
    };

    const onClickTag = async () => {
        if(!sku) return;
        if (showMode === 'full') {
            setShowMode(null);
            setimgUrl('/images/Bookmark.svg');
            return;
        }

        if (!info) {
            await fetchData();
        }
        setShowMode('full');
        setimgUrl('/images/Bookmark.svg');
    };

    const onMouseOver = () => {
        if (showMode === 'full') return;
        setShowMode('less');
        setimgUrl('/images/icon-notification-bookmark03.svg');
    };

    useEffect(() => {
        if (!mainSku || !sku) return;
        if(mainSku === sku) {
            fetchData();
            setShowMode('full');
            setimgUrl('/images/Bookmark.svg');
        }
    }, []);

    const genDetail = () => {

        if (!info || showMode === null) return <></>;

        if (showMode === 'full') {
            return (<div className={`photoLocation-sub photoLocation-sub--mw242 ` + fakePositionClass}>
                <div className="photoLocation-pro">
                    <div className="photoLocation-pro_thumb">
                        <img src={info?.imgUrl} alt="" />
                    </div>
                    <div className="photoLocation-pro_info">
                        <h4 className="tlt"><a href={'/shop/' + formatSku(info?.sku) + `/${formatSku(info?.urlKey)}` + '.html'} target="_blank" rel="noreferrer">{info?.name}</a></h4>
                        <p className="lable-text">
                            <span className="price">{numberWithCommas(info?.price)}đ</span>
                            {info?.deal_hot_discount_type === 'by_fixed' && (<span className="discount">-đ{numberWithCommas(info?.deal_hot_discount_value)}</span>)}
                            {info?.deal_hot_discount_type === 'by_percent' && (<span className="discount">-{info?.deal_hot_discount_value}%</span>)}
                            {info?.flashsales_discount_type === 'by_fixed' && (<span className="discount">-đ{numberWithCommas(info?.flashsales_discount_value)}</span>)}
                            {info?.flashsales_discount_type === 'by_percent' && (<span className="discount">-{info?.flashsales_discount_value}%</span>)}

                            <span className="view">{info?.extension_attributes.rating_summary}<img src="/images/icon-star.svg" alt="" /></span>
                        </p>
                        <div className="brand">
                            <span><img src={info?.vendorLogo} alt="" /></span>
                            {info?.vendor}
                        </div>
                    </div>
                </div>
            </div>);
        }

        if (showMode === 'less') {
            return (
                <div className="photoLocation-sub photoLocation-sub--mw165" style="transform: translate(-50%, 0.625rem);">
                    <p className="photoLocation-text">Hãy chọn sản phẩm để tag</p>
                </div>
            );
        }
    };

    return (
        <>
            <div className="photoLocation" style={{...location, position: 'absolute'}}>
                <span
                    className="item"
                    onClick={onClickTag}
                >
                    <img src={imgUrl} alt="" />
                </span>
                {genDetail()}
            </div>
        </>
    );
};